<template>
    <div
      class="modal fade"
      id="person_details"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Leads Concern Person Details</h5>
            <div class="d-flex align-items-center">
              <button
                class="btn-close custom-btn-close border p-1 me-0 text-dark"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i class="ti ti-x"></i>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <div v-if="isLoading" class="text-center py-3">
              <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
              <p class="mt-2">Loading details...</p>
            </div>
  
            <div v-else>
              <table class="table table-bordered">
                <tbody v-if="personDetails && Object.keys(personDetails).length">
                  <tr>
                    <td>Name</td>
                    <td>{{ personDetails?.name }}</td>
                  </tr>
                  <tr>
                    <td>Designation</td>
                    <td>{{ personDetails.designation ? personDetails?.designation?.name : '' }}</td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td>{{ personDetails?.phone[0] }}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>{{ personDetails?.email[0] }}</td>
                  </tr>
                  <tr>
                    <td>Gender</td>
                    <td>{{ personDetails?.gender }}</td>
                  </tr>
                  <tr>
                    <td>Influencing Role</td>
                    <td>{{ personDetails.role ? personDetails?.role.name : ''}}</td>
                  </tr>
                  <tr>
                    <td>DOB</td>
                    <td>{{ formatDate(personDetails?.dob) }}</td>
                  </tr>
                  <tr>
                    <td>Department</td>
                    <td>{{ personDetails.department ? personDetails?.department?.name : ''}}</td>
                  </tr>
                  <tr>
                    <td>Social Networks</td>
                    <td>
                        <span
                        v-for="(network, index) in personDetails?.social_networks"
                        :key="index"
                        class="badge bg-primary me-1"
                        >
                        <a
                            :href="network.url"
                            class="text-white text-decoration-none"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {{ network.social_media }}
                        </a>
                        </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex align-items-center justify-content-end m-0">
              <button class="btn btn-light me-2" data-bs-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
  <script>
  
  export default {
    data() {
        return {
            personDetails: {},
        };
    },
  
    mounted() {
      this.$emitter.on("show-persons-details", (row) => {
        this.personDetails = row
        console.log(row)
        this.$handleModal("person_details", "toggle");
      });
    },
  
    methods: {
        formatDate(date) {
          return new Date(date).toLocaleString();
        },
    },
  };
  </script>
  
  <style scoped>
  .table {
    font-size: 14px;
  }
  .spinner-border {
    width: 3rem;
    height: 3rem;
  }
  </style>
  